import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {Container, Grid, GridColumn, Icon, Button} from "semantic-ui-react";
import MobileApplyNow from "./common/MobileApplyNow";
import ApplyNow from "./common/ApplyNow";


class Terms extends PureComponent {
  static propTypes = {
    show: PropTypes.object.isRequired,
    season: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  toggleVisibility = () => this.setState({ visible: !this.state.visible });

  closeMenu = () => this.setState({ visible: false });

  render() {
    const { show, season } = this.props;
	
	let termsOfUse = require('../assets/pdf/' + process.env.REACT_APP_TERMS);
  const productionPrivacyPolicy = process.env.REACT_APP_PRODUCTION_PRIVACY_POLICY_URL;
	
	
    return (
      <div>
        <Container id="mainContent" className="ui">
          <Grid className="ui">
            <GridColumn className="pageShowTitle">
              <h3
                className="ui dividing header"
                style={{ color: `#${season.hexColorCodeC}` }}
              >
                {show.name} Casting
              </h3>
              <Button
                onClick={this.toggleVisibility}
                id="applyToggle"
                className="tiny ui primary tablet-down mobileToggle"
              >
                <Icon className="sidebar" />
                Apply Now
              </Button>
            </GridColumn>
          </Grid>

          <MobileApplyNow
            season={season}
            visible={this.state.visible} toggleVisibility={this.toggleVisibility} />

          <Grid className="ui stackable" onClick={this.closeMenu}>
            <div className="ui sixteen wide mobile eight wide computer column">
              <h1>Terms of Use</h1>

              <style>{"\
                .inner-html a {\
                  color:#" + season.hexColorCodeC + " !important;\
                }\
              "}</style>

              <div className="inner-html"
                dangerouslySetInnerHTML={{
                  __html: season.termsOfServiceC,
                }}
              />
              
              <a
                href={productionPrivacyPolicy}
                target="_blank"
                rel="noopener noreferrer"
                
              >
                <h2 style={{ color: `#${season.hexColorCodeC}` }}>
                  Privacy Policy
                </h2>
              </a>
              <a
                href={termsOfUse}
                target="_blank"
                rel="noopener noreferrer"
                download
              >
                <h2 style={{ color: `#${season.hexColorCodeC}` }}>
                  Terms of Use
                </h2>
              </a>
              <Link to="/eligibility">
                <h2 style={{ color: `#${season.hexColorCodeC}` }}>
                  Eligibility Requirements
                </h2>
              </Link>
            </div>

            <ApplyNow
              season={season}
            />

          </Grid>
        </Container>
      </div>
    );
  }
}

const mapStatesToProps = (state, ownProps) => ownProps;

export default connect(mapStatesToProps)(Terms);



// WEBPACK FOOTER //
// ./src/components/Terms.js